import { DefaultSectionCopy, Section } from "@hydrologiq/shared/providers/CopyProvider"
import { COPY_KEYS } from "@hydrologiq/shared/copy/constants"

const copy: DefaultSectionCopy = {
  type: Section.PLANNER,
  name: "Planner",
  base: "planner",
  routes: [],
  buttons: [],
  headings: [
    { name: COPY_KEYS.HEADINGS.CALENDAR, value: "Calendar" },
  ],
  statuses: [],
}

export default copy
